module.exports = __webpack_public_path__ + "assets/img/marriage-bg.b3547c18.png";